import { Link } from 'react-router-dom';
import { getLatestComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = getLatestComics(8);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="mt-2 text-sm text-foreground-500">每日准时更新，精彩不容错过</p>
          </div>
          <Link
            to="/category/romance"
            className="whitespace-nowrap hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            更多更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200"
            >
              <div className="relative overflow-hidden aspect-[3/4]">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩漫在线观看最新更新`}
                  title={`${comic.title} - 韩国漫画网最新更新`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                  <span className="text-xs text-white font-medium">
                    更新至 {comic.chapters} 话
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <div className="mt-1.5 flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{comic.categoryName}</span>
                  <span className="text-xs text-primary-600 font-medium">{comic.updateDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/romance"
            className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm font-medium text-primary-600"
          >
            更多更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}